import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Amplify, { Auth, Hub } from 'aws-amplify';
import awsconfig from './.aws-config/awsconfig'
import awsauth from './.aws-config/awsauth'
import Landing from './components/landing';
import SignIn from './components/signIn';
import SignOut from './components/signOut';

Amplify.configure(awsconfig)
Auth.configure({ oauth: awsauth })

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      // eslint-disable-next-line default-case
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          getUser()
            .then(userData => setUser(userData))

          break;
        case 'signOut':
          setUser(null);
          // console.log('signed out');
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
          console.log('Sign in failure', data);
          break;
      }
    });

    getUser().then(userData => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then(userData => userData)
      .catch(() => console.log('Not signed in'));
  }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing/>} />
          <Route path="/i" element={<SignIn/>} />
          <Route path="/o" element={<SignOut/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;